import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { AppContext } from 'contexts/TimerAppContexts/AppContext'
import { ClockContext } from 'contexts/TimerAppContexts/ClockContext'
import { Timer } from './Timer'
import { SessionEnd } from './SessionEnd'

function TimerModal() {
    const { openTimerModal} = useContext(AppContext)
    const { sessionEnd }=useContext(ClockContext)

    return ReactDOM.createPortal(
        <>
            {!sessionEnd && openTimerModal && (<Timer/>)}
            {sessionEnd && <SessionEnd/>}
        </>
        ,
        document.getElementById("timer-modal")
    )
}

export { TimerModal }